<template>
  <HelmetProvider>
    <Helmet>
      <title>{{ title }}</title>
      <!-- Facebook Tracking -->
      <script
        async=""
        :src="`https://thirdparty.jumpcloud.com/js/fb-config-${env}.min.js`"
        type="application/javascript"
      />
      <script
        async=""
        :src="`https://thirdparty.jumpcloud.com/js/fb-events-${env}.min.js`"
        type="application/javascript"
      />
      <script
        async=""
        :src="`https://thirdparty.jumpcloud.com/js/fb-inferredEvents-${env}.min.js`"
        type="application/javascript"
      />

      <!-- Google Tag Manager / Google Analytics -->
      <script type="application/javascript">
        {{ googleTagManagerScript }}
      </script>
      <!-- End Google Tag Manager / Google Analytics -->

      <!-- Pardot Tracking Script -->
      <script type="application/javascript">
        {{ pardotScript }}
      </script>
      <!-- End Pardot Tracking Script -->

      <!-- Reddit Conversion Pixel -->
      <script type="application/javascript">
        {{ redditPixel }}
      </script>

      <!-- Capterra Tracking Script DO NOT EDIT-->
      <script type="application/javascript">
        {{ capterraScript }}
      </script>
      <!-- End  Capterra Tracking Script -->
    </Helmet>
  </HelmetProvider>
</template>

<script>
import { Helmet, HelmetProvider } from '@jnields/vue-helmet';
import headMixins from 'client/signup/mixins/head';
import headScripts from 'client/signup/headScripts/headScripts';

const {
  generateGoogleTagManager,
  title,
} = headMixins;
const { capterraScript, pardotScript, redditPixel } = headScripts;

export default {
  name: 'VerifiedHead',
  components: {
    Helmet,
    HelmetProvider,
  },
  mixins: [
    generateGoogleTagManager('signup/verified'),
    title('Signup Verified'),
  ],
  data() {
    return {
      capterraScript,
      pardotScript,
      redditPixel,
    };
  },
};
</script>
